import { render, staticRenderFns } from "./ItemDescuento.vue?vue&type=template&id=652445a7&"
import script from "./ItemDescuento.vue?vue&type=script&lang=js&"
export * from "./ItemDescuento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports